import React from 'react';
import Modal from 'mf-react-ui/Modal';
import Throbber from 'mf-react-ui/Throbber';
import './LoadingModal.scss';
import '../../style.scss';

type Props = {
  isOpen: boolean;
  onClose?: () => void;
  hideModal: () => void;
};

const LoadingModal: React.FC<Props> = (props) => {
  const { isOpen, onClose, hideModal } = props;
  const handleCloseButtonClick = () => {
    if (onClose) {
      onClose();
    }

    hideModal();
  };

  return (
    <Modal
      titleText="Загрузка"
      isOpen={isOpen}
      className="modal_loading modal_content-center"
      onCloseButtonClick={handleCloseButtonClick}
    >
      <Throbber className="throbber-dialog__throbber" />
    </Modal>
  );
};

export default LoadingModal;
